export enum AuthPaths {
	Default = '/auth',
	Login = '/auth/logowanie',
	Registration = '/auth/rejestracja',
	PasswordReset = '/auth/reset-hasla/:hash?',
	EmailConfirmation = '/auth/potwierdzenie-email/:hash'
}